// Be aware that the name will be checked by 'includes' which does a 'startsWith' by comparison
export enum STEP {
  REAL_ESTATE_TYPE = 'realEstateType',
  IBW_REAL_ESTATE_TYPE = 'ibwRealEstateType',
  LOCATION = 'location',
  AREA = 'area',
  ROOMS = 'rooms',
  INTENT = 'intent',
  BUYER_LEADS_VALUE_PROPOSITION = 'buyerLeadsValueProposition',
  SELL_INTENT = 'realtorQuestion',
  REINFORCEMENT = 'reinforcement',
  DEV_COM_OFFER = 'devComOffer',
  TIME_HORIZON = 'timeHorizon',
  OWNER = 'owner',
  PARTIAL_SALE = 'partialSale',
  PLEASE_WAIT = 'pleaseWait',
  CONTACT = 'contact',
  ADDRESS = 'address',
  CONSTRUCTION_YEAR = 'constructionYear',
  INITIAL = '#RLE.realEstateType',
  IBW_INITIAL = '#RLE.ibwRealEstateType',
  RESPONSE = 'response',
  RESPONSE_EXTENDED_BUYER_LEADS = 'buyerLeadsExtendedResponse',
  RESPONSE_NON_HAPPY_PATH = 'nonHappyPathResponse',
  PDF_LOADING = 'pdfLoading',
  PDF_DOWNLOAD = 'pdfDownload',
  PDF_ERROR = 'pdfError',
  LAND_DEVELOPMENT_POTENTIAL = 'landDevelopmentPotential',
  LAND_DEVELOPMENT_STATUS = 'landDevelopmentStatus',
  LAND_LAYOUT = 'landLayout',
  FLOW_SETUP = 'flowSetup',
  COMMERCIAL_REAL_ESTATE_TYPE = 'commercialRealEstateType',
  REAL_ESTATE_SUBTYPE = 'realEstateSubtype',
  FURNISHING_TYPE = 'furnishingType',
  ERROR = 'error',
  EMPLOYMENT = 'employment',
  EQUITY = 'equity',
  INCOME = 'income',
  SOLAR = 'solar',
  PLACEMENT_TYPE = 'placementType',
  SOLAR_INTENT = 'solarIntent',
  RESPONSE_SOLAR = 'solarResponse',
  CONSULTATION = 'consultation',
  EXTENDED_BUYER_LEADS_OVERVIEW = 'extendedBuyerLeadsOverview',
  RADIUS = 'radius',
  RENT_OUT_REINFORCEMENT = 'rentOutReinforcement',
  RENT_OUT_INTENT = 'rentOutIntent',
}

export enum RealEstateTypeFlow {
  APARTMENT = 'apartment',
  HOUSE = 'house',
  LAND = 'land',
  COMMERCIAL = 'commercial',
}

export enum IBWRealEstateTypeFlow {
  APARTMENT = 'ibw_apartment',
  HOUSE = 'ibw_house',
  LAND = 'ibw_land',
  COMMERCIAL = 'ibw_commercial',
}

export enum ACTION {
  NEXT = 'next',
  BACK = 'back',
  GO_TO_ERROR = 'goToError',
}
